type TriangleProps = {
  cx: number;
  cy: number;
  fill: string;
  size?: number;
  upsideDown?: boolean;
};

export const Triangle: React.FC<TriangleProps> = ({ cx, cy, size = 10, fill, upsideDown = false }) => {
  const transform = upsideDown ? `rotate(180 ${cx} ${cy})` : undefined;

  return (
    <path
      d={`
        M${cx} ${cy - size / 2}
        L${cx - size / 2} ${cy + size / 2}
        L${cx + size / 2} ${cy + size / 2}
        Z
      `}
      fill={fill}
      transform={transform}
    />
  );
};
